export const MAX_UPLOAD_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
